import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-small);
	align-items: center;
	padding: var(--spacing-medium-small) var(--spacing-large);
	background-color: var(--neutrals-50);
	border-radius: inherit;

	.motif-icon {
		&.orange {
			color: var(--orange-200);
		}
		&.blue {
			color: var(--blue-600);
		}
	}
`;
